import { AfterViewInit, Component, Input, signal } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { LoPacMessage } from '@core/model';

type MessageType = 'success' | 'info' | 'warn' | 'error';
type CollapsingType = 'start' | 'closed' | 'open';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-custom-message',
    templateUrl: './custom-message.component.html',
    styleUrls: ['./custom-message.component.scss'],
    animations: [
        trigger('openClose', [
            state('start', style({
                height: 0,
                visibility: 'hidden',
                margin: 0
            })),
            state('open', style({
                height: '*',
                visibility: 'visible'
            })),
            state('closed', style({
                height: 0,
                visibility: 'hidden',
                margin: 0
            })),
            transition('open => closed', [
                animate('0.2s')
            ]),
            transition('closed => open', [
                animate('0.3s ease-in')
            ]),
        ]),
    ],
    standalone: false
})
export class CustomMessageComponent implements AfterViewInit {
  @Input() message: LoPacMessage  = null;
  @Input() isInline = false;
  @Input() isClosable = false;
  @Input() isExpandable = false;

  isShown = true;
  isCollapsed = false;

  collapsingState = signal<CollapsingType>('start');

  ngAfterViewInit() {
    this.handleCollapsing();
  }

  handleCollapsing(): void {
    if (!this.isExpandable) {
      return this.collapsingState.set('open');
    }

    this.isCollapsed = !this.isCollapsed;

    this.collapsingState.set(this.isCollapsed ? 'closed' : 'open');
  }
}
